__turbopack_context__.v({
  "className": "hanken_grotesk_4deabf22-module__ht46kW__className",
});
